import '../AcmgReportStatus.css';
import React from 'react';
import {Col, Row} from 'antd';
import {isRTL, useLanguage} from "../LanguageContext";

interface AcmgReportStatusRowProps {
    index: number;
    svgIcon: string;
    label: string;
    checked: boolean;
    statusDescription?: string
}


const AcmgReportStatusRow: React.FC<AcmgReportStatusRowProps> = (props: AcmgReportStatusRowProps) => {
    const {language} = useLanguage();
    const className = isRTL(language) ? 'rtl' : 'ltr';

    return (
        <Row className="status-row">
            <Col span={3}>
                <img className={`status-icon ${className}`} src={props.svgIcon} alt={`SVG ${props.index}`}/>
            </Col>
            <Col className="index-colum" span={3}>
                <div className={`status-index ${className} ${props.checked ? 'status-index-checked' : ''}`}>
                    {props.index + 1}
                </div>
                <div className="status-vertical-line"></div>
            </Col>
            <Col span={10}>
                <div className={`status-label ${className} ${props.checked ? 'status-label-checked' : ''}`}>
                    {props.label}
                </div>
            </Col>
        </Row>
    );
}

export default AcmgReportStatusRow;
